import { css, keyframes } from "@emotion/react";
import styled from "@emotion/styled";

const blink = keyframes`
  0% {
    opacity: 0.2;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
`;

const Dot = styled.div`
  display: inline-block;
  margin: 0 2px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #5c75b1;
  animation: ${blink} 1.4s infinite both;

  &:nth-of-type(2) {
    animation-delay: 0.2s;
  }

  &:nth-of-type(3) {
    animation-delay: 0.4s;
  }
`;

const BlurOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(0.1px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;

const InputContainer = styled.div`
  position: relative;
  display: flex;
`;

const SC = {
  Dot,
  BlurOverlay,
  InputContainer,
};

export default SC;
